module.exports = __webpack_public_path__ + "static/s3-icons-40162c5b9cf5d257f4e5550fe60a9357.png";